<router-outlet *ngIf="navbarActive"></router-outlet>



// WEBPACK FOOTER //
// /opt/app/src/app/app.component.html